// ====== Basics ======
const modal = document.getElementById('in9iteL3F2EdR8NPy');
const modalBody = document.getElementById('quickview-body');

function fetchQuickviewViaView(handle) {
    return `<iframe border="0" height="625" src="/products/${handle}?view=quickview" style="min-width: 320px; width: 100%; height: 625px; padding:0; max-width: 780px;"></iframe>`;
}

function openModal() {
    modal.setAttribute('data-state', 'open');
    modalBody.setAttribute('aria-busy', 'true');

    const prev = document.activeElement;
    modal.dataset.prevFocus = prev && prev.closest('body') ? prev.selector || '' : '';
    modalBody.focus();
}

// ====== Klick -> aus Cache oder Fetch laden, dann zeigen ======
document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quickview-handle]');
    if (!trigger) return;
    e.preventDefault();

    const handle = trigger.getAttribute('data-quickview-handle');
    openModal();

    try {
        const html = fetchQuickviewViaView(handle);
        modalBody.removeAttribute('aria-busy');
        modalBody.innerHTML = html;
    } catch (err) {
        console.error(err);
        modalBody.removeAttribute('aria-busy');
        modalBody.innerHTML = '<p class="error">Ups, Quick View konnte nicht geladen werden.</p>';
    }
});

